import { render, staticRenderFns } from "./NoteDetailsVersionModal.vue?vue&type=template&id=6177829c&scoped=true&"
import script from "./NoteDetailsVersionModal.vue?vue&type=script&lang=js&"
export * from "./NoteDetailsVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetailsVersionModal.vue?vue&type=style&index=0&id=6177829c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6177829c",
  null
  
)

export default component.exports